"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BODY_MARKER_ATTRIBUTE = void 0;
const BODY_MARKER_ATTRIBUTE = "data-smar-theme-key";
exports.BODY_MARKER_ATTRIBUTE = BODY_MARKER_ATTRIBUTE;
//# sourceMappingURL=ThemeMarkerAttribute.js.map